"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteBackgroundSync = exports.setBackgroundSync = void 0;
var devices_1 = require("../src/devices");
var backgroundModule = function () {
    var _a;
    var backgroundService = (_a = window.bleb) === null || _a === void 0 ? void 0 : _a.BackgroundSync;
    if (backgroundService) {
        return backgroundService;
    }
    else {
        throw new Error('bleb is missing in current browser');
    }
};
var getDeviceInfo = function (type) {
    switch (type) {
        case "Alto2":
            return devices_1.Alto2Info;
        case "ePod2":
            return devices_1.ePod2Info;
        case "ePod3":
            return devices_1.ePod3Info;
        case "ePod":
            return devices_1.ePodProfile;
        default:
            return devices_1.ePodProfile;
    }
};
var boolToNum = function (flag) {
    if (typeof flag === 'number') {
        return flag;
    }
    return flag ? 1 : 0;
};
var setBackgroundSync = function (deviceType, deviceId, value) {
    var deviceInfo = getDeviceInfo(deviceType);
    var characteristicId = deviceInfo.VAPING.characteristics.find(function (c) { return c.name === "LOCK"; }).uuid;
    var type = "write";
    if (deviceType === "ePod3" && value.lockMode) {
        var arrayBuffer = new ArrayBuffer(4);
        var backgroundValues = new DataView(arrayBuffer);
        backgroundValues.setUint8(0, boolToNum(value.locked));
        backgroundValues.setUint8(1, value.lockMode);
        backgroundValues.setUint16(2, value.bleTimeout);
        backgroundModule().setBackgroundSync({
            type: type,
            deviceId: deviceId,
            characteristicId: characteristicId,
            value: '',
            valueData: backgroundValues.buffer,
        });
    }
    else {
        backgroundModule().setBackgroundSync({
            type: type,
            deviceId: deviceId,
            characteristicId: characteristicId,
            value: value,
        });
    }
};
exports.setBackgroundSync = setBackgroundSync;
var deleteBackgroundSync = function (deviceId) {
    var type = "write";
    backgroundModule().deleteBackgroundSync({ type: type, deviceId: deviceId });
};
exports.deleteBackgroundSync = deleteBackgroundSync;
